module.exports = __webpack_public_path__ + "img/Qualification_3.0f5a9c1c.jpg";